module.exports = __webpack_public_path__ + "static/media/18ECA21.b9ead87b.jpg";